export const LoginActionConst = "LOGIN_ACTION_CONST"
export const LoginResultConst = "LOGIN_RESULT_CONST"
export const LoginActionByTokenConst = "LOGIN_BY_TOKEN_ACTION_CONST"
export const LoginActionByTokenResultConst = "LOGIN_BY_TOKEN_RESULT_CONST"

export const EditModeConst = "EDIT_MODE_CONST"

export const MouseLngLatPositionConst = "MOUSE_LNG_LAT_POSITION_ACTION_CONST"

export const AdminRoadEnableDisbaleConst = "ADMIN_ROAD_ENABEL_DISABLE_ACTION_CONST"

export const AdminDetailObject3DConst = "ADMIN_DETAIL_OBJ3D_ACTION_CONST"

export const AdminActionPadModeConst = "ADMIN_ACTION_PAD_MODE_CONST"
export const AdminActionCaravanserailStreetLinkingConst = "AdminActionCaravanserailStreetLinkingConst"

export const UserActionCaravanserailOpenConst = "USER_ACTION_CARAVANSERAIL_OPEN_CONST"
export const UserActionCaravanserailOpenConstResult = "USER_ACTION_CARAVANSERAIL_OPEN_CONST_RESULT"

export const UserActionOpenCloseChatPrivateConst = "USER_ACTION_OPEN_CLOSE_CHAT_PRIVATE_CONST"